export const UPDATE_NUM_ENTRIES = 'UPDATE_LAST_ENTITY_TO_ENTER';
export const UPDATE_IS_RESTORING_SCROLL_POSITION =
  'UPDATE_IS_RESTORING_SCROLL_POSITION';
export const TOGGLE_IS_ACTIVITY_VIDEO_MUTED = 'TOGGLE_IS_ACTIVITY_VIDEO_MUTED';

export default {
  UPDATE_NUM_ENTRIES,
  UPDATE_IS_RESTORING_SCROLL_POSITION,
  TOGGLE_IS_ACTIVITY_VIDEO_MUTED
};
